// extracted by mini-css-extract-plugin
export default {"fullWidth":"fo-z","image":"go-z","lazyLoadPicture":"ho-z","lazyLoadSpinner":"io-z","lazyLoadSpin":"jo-z","lazyLoadImage":"ko-z","hasStyledAspectRatio":"lo-z"};